/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";

export const patchedStaffRequestSchema = z.object({
	tg_id: z.bigint().nullish().describe("Уникальный идентификатор пользователя в Telegram"),
	tg_username: z.string().max(63).nullish().describe("Username пользователя в Telegram"),
	org_unit: z.uuid().nullish(),
});
